import { useContext, useState } from "react";
import { Button, Input } from "../../../ui";
import { Context } from "../../../../context/Context";
import { useAccess } from "../../../../access/hooks/useAccess";
import { cancelSubscriptionNowAPI, convertGrantToPaidAPI, extendGrantAPI } from "../../../../utils/api/billing";
import { grantText } from "../grantText";

/*
  Extend / convert to paid / cancel an administrator-granted subscription. Every action needs a reason; convert and cancel also need the
  explicit confirmation (the button itself, after the consequence is stated). The server enforces the role and the rules again.
*/
const GrantActionModal = ({ mode, subscription, onCancel, onDone }) => {
  const { lang } = useContext(Context);
  const { can } = useAccess();
  const t = grantText(lang);
  const token = localStorage.getItem("auth-token");
  const [reason, setReason] = useState("");
  const [endDate, setEndDate] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const title = { extend: t.extendTitle, convert: t.convertTitle, cancel: t.cancelTitle }[mode];
  const body = { extend: "", convert: t.convertBody, cancel: t.cancelBody }[mode];
  const currentEnd = subscription?.grant?.endDate ? String(subscription.grant.endDate).slice(0, 10) : "";
  const ready = reason.trim() && (mode !== "extend" || (endDate && endDate > currentEnd));

  const run = async () => {
    // handler-level authorization: the server refuses anyone else as well
    if (!can("billing.subscription.grant") || saving || !ready) return;
    setSaving(true);
    setError("");
    try {
      if (mode === "extend") await extendGrantAPI(token, subscription._id, { endDate, reason: reason.trim() });
      if (mode === "convert") await convertGrantToPaidAPI(token, subscription._id, { reason: reason.trim(), confirm: true });
      if (mode === "cancel") await cancelSubscriptionNowAPI(token, subscription._id, { reason: reason.trim(), confirm: true });
      await onDone();
    } catch (err) {
      setError(err.message);
      setSaving(false);
    }
  };

  return (
    <div className="billing-modal-backdrop" dir={lang === "ar" ? "rtl" : "ltr"}>
      <div className="billing-modal" role="dialog" aria-modal="true" aria-label={title}>
        <h3>{title}</h3>
        {body && <p>{body}</p>}
        {error && <div className="billing-error" role="alert">{error}</div>}
        <div className="billing-plan-modal-form">
          {mode === "extend" && <Input type="date" label={t.newEndDate} required min={currentEnd || undefined} value={endDate} onChange={(event) => setEndDate(event.target.value)} />}
          <Input textarea label={t.actionReason} required value={reason} onChange={(event) => setReason(event.target.value)} />
        </div>
        <div className="billing-modal-actions">
          <Button appearance="outline" disabled={saving} onClick={onCancel}>{t.cancel}</Button>
          <Button appearance="filled" disabled={!ready || saving} onClick={run}>{saving ? t.saving : title}</Button>
        </div>
      </div>
    </div>
  );
};

export default GrantActionModal;
